<template>
  <div class="table-box" :class="[zsTjTheme]">
    <div class="table-header">
      <span>{{ $t("tj.zs.sx") }}</span>
      <span>{{ $t("tj.zs.dqsz") }}</span>
    </div>
    <div class="table-content">
      <div v-for="key in Object.keys(calcDataSrource)" :key="key" class="line">
        <div class="label">
          <SvgIcon class="icon" :iconClass="`zs-tj-attr-icon${key.replace('attr', '')}`" />
          <span class="name">{{ $t(`tj.zs.${calcDataSrource[key].name.value}`) }}</span>
        </div>
        <div class="value">
          <span class="default">{{
            (calcAttributeData[calcDataSrource[key].name.value] &&
              `${getCurrentValue(
                calcAttributeData[calcDataSrource[key].name.value].value,
                calcDataSrource[key].name.value
              )}${
                typeof calcAttributeData[calcDataSrource[key].name.value].defaultValue == "string" &&
                calcAttributeData[calcDataSrource[key].name.value].defaultValue.includes("%")
                  ? "%"
                  : ""
              }`) ||
              "-"
          }}</span>
          <span class="up">
            （{{ getDiffData(calcAttributeData[calcDataSrource[key].name.value], calcDataSrource[key].name.value) }}）
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPropertyOptions } from "@/views/wiki/zbtj/zs/abcs";
import { getResultValue } from "../index";
import { mapGetters } from "vuex";
import langMap from "../../../langMap";

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    },
    styleData: {
      type: Object,
      default: () => ({})
    },
    // 皮肤数据
    skinObj: {
      type: Object,
      default: () => ({})
    },
    // 装备数据
    equipmentObj: {
      type: Object,
      default: () => ({})
    },
    // 珍藏数据
    treasureData: {
      type: Array,
      default: () => []
    },
    // 共用能力值
    publicData: {
      type: Object,
      default: () => ({})
    },
    // 刻印数据
    engravingData: {
      type: Object,
      default: () => ({})
    },
    // 觉醒数据
    awakeningData: {
      type: Object,
      default: () => ({})
    },
    // 角色数据
    character: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    skinList() {
      return Object.keys(this.styleData).filter(key => {
        return this.styleData[key].icon.hasValue;
      });
    },
    // 皮肤技能数据
    calcStyleData() {
      const result = {};
      for (let i = 0; i < this.skinList.length; i++) {
        const key = this.skinList[i];
        const item = this.styleData[key];
        result[key] = {
          skillData: {
            name: this.getPublicInfos(item.skill.ability1.desc.value, "name"),
            value: this.getPublicInfos(item.skill.ability1.desc.value, "value")
          }
        };
      }
      return result;
    },
    calcDataSrource() {
      const result = {};
      const keys = Object.keys(this.dataSource);
      let attr = this.character && this.character.attr2 && this.character.attr2.name && this.character.attr2.name.value;
      attr = langMap[attr] || attr; // 处理语言映射

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const item = this.dataSource[key];
        if ((attr === "魔法" && item.name.value !== "攻击力") || (attr === "物理" && item.name.value !== "魔法力")) {
          result[key] = {
            ...item,
            name: {
              ...item.name,
              value: this.getPropertyLabel(item.name.value)
            }
          };
        }
      }
      return result;
    },
    calcSourceKeys() {
      const result = [];
      const keys = Object.keys(this.calcDataSrource);
      keys.forEach(key => {
        const item = this.calcDataSrource[key];
        if (item && item.name && item.name.value) {
          result.push(item.name.value);
        }
      });
      return result;
    },
    // 计算数值
    calcAttributeData() {
      const obj = {};
      for (let i = 0; i < this.calcSourceKeys.length; i++) {
        const key = this.calcSourceKeys[i];
        obj[key] = {
          count: [],
          percent: []
        };
      }
      // 计算装备
      for (let key in this.equipmentObj) {
        const item = this.equipmentObj[key];
        const abcsData = item.abcsCalcData || {};
        // 先计算基础属性
        const mainAttr = item.mainAttr;
        const jbnl1Key = mainAttr.jbnl1 ? mainAttr.jbnl1.label : "";
        const jbnl1Val = mainAttr.jbnl1 ? mainAttr.jbnl1.value : 0;
        if (jbnl1Val && obj[jbnl1Key]) {
          (String(jbnl1Val).indexOf("%") !== -1 ? obj[jbnl1Key].percent : obj[jbnl1Key].count).push(jbnl1Val);
        }
        // 加abcs附件值
        if (abcsData.jbnl1) {
          const abcsJbnl1Val = abcsData.jbnl1;
          if (obj[jbnl1Key]) {
            (String(abcsJbnl1Val).indexOf("%") !== -1 ? obj[jbnl1Key].percent : obj[jbnl1Key].count).push(abcsJbnl1Val);
          }
        }
        if (item.type === "专用") {
          const zynlKey = mainAttr.zynl ? mainAttr.zynl.label : "";
          const zynlVal = mainAttr.zynl ? mainAttr.zynl.value : 0;
          if (zynlVal && obj[zynlKey]) {
            (String(zynlVal).indexOf("%") !== -1 ? obj[zynlKey].percent : obj[zynlKey].count).push(zynlVal);
          }

          // 加abcs附件值 专武的第一个属性运营说不能加abcs
          // if (abcsData.zynl) {
          //   const abcsZynlVal = abcsData.zynl;
          //   if (obj[zynlKey]) {
          //     (String(abcsZynlVal).indexOf("%") !== -1 ? obj[zynlKey].percent : obj[zynlKey].count).push(abcsZynlVal);
          //   }
          // }

          // 计算专用属性
          const zynl2List = mainAttr.jbnl2 || [];
          const zwIndex = item.zwIndex || 0;
          const abcsList = abcsData.jbnl2 || [];
          const zynl2Key = zynl2List[zwIndex] ? zynl2List[zwIndex].label : "";
          const zynl2Val = zynl2List[zwIndex] ? zynl2List[zwIndex].value : 0;
          const abcsZynl2Val = abcsList[zwIndex] ? abcsList[zwIndex] : 0;
          if (zynl2Val && obj[zynl2Key]) {
            (String(zynl2Val).indexOf("%") !== -1 ? obj[zynl2Key].percent : obj[zynl2Key].count).push(
              zynl2Val,
              abcsZynl2Val
            );
          }
        } else {
          // 计算通用属性
          const jbnl2Key = mainAttr.jbnl2 ? mainAttr.jbnl2.label : "";
          const jbnl2Val = mainAttr.jbnl2 ? mainAttr.jbnl2.value : 0;
          if (jbnl2Val && obj[jbnl2Key]) {
            (String(jbnl2Val).indexOf("%") !== -1 ? obj[jbnl2Key].percent : obj[jbnl2Key].count).push(jbnl2Val);
          }

          // 加abcs附件值
          if (abcsData.jbnl2) {
            const abcsJbnl2Val = abcsData.jbnl2;
            if (obj[jbnl2Key]) {
              (String(abcsJbnl2Val).indexOf("%") !== -1 ? obj[jbnl2Key].percent : obj[jbnl2Key].count).push(
                abcsJbnl2Val
              );
            }
          }
        }

        // 附加属性
        const otherProperty = item.propertyData;
        const list = getPropertyOptions(item);
        otherProperty &&
          otherProperty.forEach(property => {
            const current = list[property];
            if (current) {
              const key = current.label;
              const value = current.value;
              if (value && obj[key]) {
                (String(value).indexOf("%") !== -1 ? obj[key].percent : obj[key].count).push(value);
              }
            }
          });
      }

      // 计算共用能力
      for (let key in this.calcStyleData) {
        const item = this.calcStyleData[key];
        const calcItem = this.publicData && this.publicData[key];
        if (item && item.skillData) {
          const name = item.skillData.name;
          const value = calcItem && calcItem.value ? calcItem.value : item.skillData.value;
          if (value && name && obj[name]) {
            (String(value).indexOf("%") !== -1 ? obj[name].percent : obj[name].count).push(value);
          }
        }
      }

      // 珍藏集收益
      this.treasureData.forEach(item => {
        const name = item.name;
        const value = item.value;
        if (value && name && obj[name]) {
          (String(value).indexOf("%") !== -1 ? obj[name].percent : obj[name].count).push(value);
        }
      });

      // 皮肤数据
      if (this.skinObj.bindData && this.skinObj.bindData.length) {
        this.skinObj.bindData.forEach(item => {
          const name = item.name;
          const value = item.value;
          if (value && name && obj[name]) {
            (String(value).indexOf("%") !== -1 ? obj[name].percent : obj[name].count).push(value);
          }
        });
      }

      // 刻印数据
      for (let key in this.engravingData) {
        // 取消前后\n \r
        const currentKey = key
          .trim()
          .replace("\r", "")
          .replace("\n", "");
        const value = this.engravingData[key];
        if (obj[currentKey] && value) {
          (String(value).indexOf("%") !== -1 ? obj[currentKey].percent : obj[currentKey].count).push(value);
        }
      }

      // 觉醒数据
      for (let key in this.awakeningData) {
        // 取消前后\n \r
        const currentKey = key
          .trim()
          .replace("\r", "")
          .replace("\n", "");
        const value = this.awakeningData[key];
        if (obj[currentKey] && value) {
          (String(value).indexOf("%") !== -1 ? obj[currentKey].percent : obj[currentKey].count).push(value);
        }
      }

      const result = {};
      const keys = Object.keys(this.calcDataSrource);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];

        const item = this.calcDataSrource[key];
        const name = item.name.value;
        let originValue = item.level100 ? Number(getResultValue(item.level100.value)) : 0;

        const defaultValue = item.level100 ? item.level100.value : 0;
        const countArr = obj[name] ? obj[name].count : [];
        const percentArr = obj[name] ? obj[name].percent : [];
        const count = countArr.reduce((prev, next) => {
          const val = this.getCurrentValue(next, name);
          return prev + parseFloat(val);
        }, 0);
        const percent = percentArr.reduce((prev, next) => {
          // 处理百分比字符串, 将百分比转换为数字
          next = next.replace("%", "");
          next = next.trim();
          return prev + parseFloat(next || 0);
        }, 0);
        // 如果是百分号类型的数据，将百分数据累加
        if (defaultValue && String(defaultValue).indexOf("%") !== -1) {
          if (percent) {
            originValue = originValue + percent;
          }
        } else {
          if (countArr.length) {
            originValue = originValue + count;
          }
          if (percentArr.length) {
            originValue = originValue * (percent / 100 + 1);
          }
        }

        result[name] = {
          defaultValue,
          value: this.getValue(originValue)
        };
      }

      return result;
    }
  },
  data() {
    return {};
  },
  methods: {
    getPropertyOptions,
    getPublicInfos(string, type) {
      if (!string) return "";
      const arr = string.split("：");
      if (type === "name") {
        return arr[0] ? arr[0].trim() : ""; // 返回名称部分
      }
      return arr[1] ? arr[1].trim() : ""; // 返回数值部分
    },
    getValue(val) {
      // 如果val有小数点，保留两位小数，如果没有小数点，返回整数
      return Number(val) % 1 === 0 ? val.toString() : Number(val).toFixed(2);
    },
    getPropertyLabel(name) {
      if (name === "暴击率") return this.$t("tj.zs.zml");
      if (name === "暴击伤害") return this.$t("tj.zs.zmsh");
      return name;
    },
    getDiffData(data, key) {
      const value = data.value ? Number(data.value) : 0;
      let defaultValue = data.defaultValue ? data.defaultValue : 0;
      const isPercent = String(defaultValue).indexOf("%") !== -1;
      if (defaultValue && typeof defaultValue === "string") {
        defaultValue = Number(defaultValue.replace("%", "").trim());
      }
      if (value === defaultValue) return `${isPercent ? "+0%" : "+0"}`;
      let diff = this.getValue(value - defaultValue);
      if (key === "攻击力" || key === "魔法力") {
        diff = parseInt(diff); // 不保留小数
      }
      if (value > defaultValue) {
        return `+${isPercent ? diff + "%" : diff}`;
      } else {
        return `-${isPercent ? diff + "%" : diff}`;
      }
    },
    getCurrentValue(value, name) {
      if (name === "攻击力" || name === "魔法力") {
        // 不保留小数
        return parseInt(value);
      }
      return value;
    }
  }
};
</script>
<style lang="less" scoped>
.table-box {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  .table-header {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    height: 43px;
    margin-bottom: 20px;
    padding: 0 28px 0 10px;
    line-height: 42px;
    font-weight: bold;
    font-size: 16px;
    color: #999999;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  }
  .table-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    /* 滚动槽 */
    &::-webkit-scrollbar {
      display: none;
      width: 4px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #95cde7;
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 28px;
      .label {
        display: flex;
        align-items: center;
        .icon {
          width: 22px;
          height: 22px;
          margin-right: 9px;
        }
        .name {
          font-size: 17px;
          font-weight: 600;
          color: #ffffff;
        }
      }
      .value {
        color: #fff;
        font-size: 17px;
        font-weight: 600;
        .up {
          color: #ffbf30;
        }
      }
    }
  }
}

.table-box.light {
  .table-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }
  .table-content {
    .line {
      .label {
        .name {
          font-weight: 800;
          color: #333333;
        }
      }
      .value {
        font-weight: 800;
        color: #333333;
        .up {
          color: #ff6600;
        }
      }
    }
  }
}
</style>
